import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

export interface BreadcrumbItemData {
    label: string;
    href?: string;
    dataTour?: string;
}

interface BreadcrumbsProps {
    items: BreadcrumbItemData[];
    showHome?: boolean;
}

const Breadcrumbs = ({ items, showHome = true }: BreadcrumbsProps) => {
    return (
        <Breadcrumb>
            <BreadcrumbList>
                {showHome && (
                    <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                            <Link to="/" className="flex items-center gap-1 hover:text-foreground transition-colors">
                                <Home className="w-3.5 h-3.5" />
                                Home
                            </Link>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                )}
                {items.map((item, index) => (
                    <div key={index} className="flex items-center">
                        {(showHome || index > 0) && <BreadcrumbSeparator />}
                        <BreadcrumbItem>
                            {item.href ? (
                                <BreadcrumbLink asChild>
                                    <Link to={item.href} className="hover:text-foreground transition-colors">
                                        {item.label}
                                    </Link>
                                </BreadcrumbLink>
                            ) : (
                                <BreadcrumbPage data-tour={item.dataTour}>{item.label}</BreadcrumbPage>
                            )}
                        </BreadcrumbItem>
                    </div>
                ))}
            </BreadcrumbList>
        </Breadcrumb>
    );
};

export default Breadcrumbs;
